// import MainLayout from '@Layout/MainLayout';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/files')({
    // component: MainLayout,
});
